import { CIMSModal } from 'components/CIMSModal'
import { simpleSuccessNotification } from 'hooks/notificationHandler'
import React from 'react'
import {
  useRouteDesignSubmittalMutation,
  useGiveDesignSubmittalDispositionMutation,
} from 'schema'
import { DSStatus } from '@cims-online/shared'
import { DisciplineAction } from './DisciplineAction'
import { RouterReview } from './RouterReview'
import { useDesignSubmittalLogContext } from '../../../../DesignSubmittalLogContext'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { RouterReviewValues } from './RouterReview/types'
import { DisciplineActionValues } from './DisciplineAction/types'

export const AdvancementModal: React.FC = () => {
  const {
    refetch,
    advancementModal: { visible, toggle, state },
  } = useDesignSubmittalLogContext()
  // route
  const [route, { loading: routeLoading }] = useRouteDesignSubmittalMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      routeDesignSubmittal: {
        designSubmittal: { sharePointFolderName },
      },
    }) =>
      simpleSuccessNotification(
        `${sharePointFolderName} successfully sent to ${DSStatus.DisciplineAction.name}`
      ),
  })
  // disposition
  const [giveDisposition, { loading: dispositionLoading }] =
    useGiveDesignSubmittalDispositionMutation({
      ...DefaultMutationHookOptions,
      onCompleted: ({
        giveDesignSubmittalDisposition: {
          designSubmittal: { sharePointFolderName },
        },
      }) =>
        simpleSuccessNotification(
          `${sharePointFolderName} successfully ${DSStatus.ReturnedToDesignBuilder.name} `
        ),
    })
  return (
    <CIMSModal
      title={DSStatus.fromId(state?.statusId)?.name}
      visible={visible}
      width="narrow"
      loading={routeLoading || dispositionLoading}
      onCancel={() => toggle(null)}
      onOk={async (values) => {
        if (state?.statusId === DSStatus.RouterReview.id) {
          const { disciplineIds, actionIds, contractDueDate, comment } =
            values as RouterReviewValues
          await route({
            variables: {
              routeDesignSubmittalInput: {
                id: state?.id,
                actionIds,
                disciplineIds,
                contractDueDate: contractDueDate.toISOString(),
                comment,
              },
            },
          })
          await refetch()
        } else if (state?.statusId === DSStatus.DisciplineAction.id) {
          const { disposition, comment } = values as DisciplineActionValues
          await giveDisposition({
            variables: {
              giveDesignSubmittalDispositionInput: {
                id: state?.id,
                disposition,
                comment,
              },
            },
          })
          await refetch()
        }
        toggle(null)
      }}
    >
      {state?.statusId === DSStatus.RouterReview.id && <RouterReview />}
      {state?.statusId === DSStatus.DisciplineAction.id && <DisciplineAction />}
    </CIMSModal>
  )
}
